import React, { useState, useEffect, useRef } from 'react';
import './AllCourtsScreen.css';
import sponsor1Logo from '../sponsor/AMERICANSTEELS.png';
import sponsor2Logo from '../sponsor/AMEYA.png';
import sponsor3Logo from '../sponsor/ECA.png';
import sponsor4Logo from '../sponsor/express logo.png';
import sponsor5Logo from '../sponsor/GB_SOLAR.png';
import sponsor6Logo from '../sponsor/GFCL.png';
import sponsor7Logo from '../sponsor/MG.png';
import sponsor8Logo from '../sponsor/NAKODA.png';
import sponsor9Logo from '../sponsor/RATNAVEER.png';
import sponsor10Logo from '../sponsor/RUBAMIN.png';
import sponsor11Logo from '../sponsor/SILOX_INDIA.png';
import sponsor12Logo from '../sponsor/SURE_SAFTY.png';
import sponsor13Logo from '../sponsor/VAISHVI.png';
import sponsor14Logo from '../sponsor/VMC.png';
import sponsor15Logo from '../sponsor/VSPF.png';

const AllCourtsScreen = () => {
  const [liveMatchesByGroup, setLiveMatchesByGroup] = useState({});
  const [nextMatchesByGroup, setNextMatchesByGroup] = useState({});
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [error, setError] = useState(null);
  const pollingIntervalRef = useRef(null);

  const API_BASE_URL = 'https://api.asterickx.com/api/MatchScoring';
  const API_ALL_LIVE = `${API_BASE_URL}/GetAllLiveScore`;
  const TOURNAMENT_ID = '7f479cd9-9169-488b-8f06-dc57b6ab64b1';
  const API_SIDE_LABELS = `${API_BASE_URL}/tournament/${TOURNAMENT_ID}/side-labels`;

  const courts = [
    { id: 'court1', name: 'Court 1', courtNumber: 1 },
    // { id: 'court2', name: 'Court 2', courtNumber: 2 },
  ];

  const sponsors = [
    { id: 1, name: 'Sponsor 1', logo: sponsor1Logo },
    { id: 2, name: 'Sponsor 2', logo: sponsor2Logo },
    { id: 3, name: 'Sponsor 3', logo: sponsor3Logo },
    { id: 10, name: 'Sponsor 10', logo: sponsor10Logo },
    { id: 7, name: 'Sponsor 7', logo: sponsor7Logo },

    { id: 4, name: 'Sponsor 4', logo: sponsor4Logo },
    { id: 5, name: 'Sponsor 5', logo: sponsor5Logo },
    { id: 6, name: 'Sponsor 6', logo: sponsor6Logo },
    { id: 8, name: 'Sponsor 8', logo: sponsor8Logo },
    { id: 9, name: 'Sponsor 9', logo: sponsor9Logo },
    { id: 11, name: 'Sponsor 11', logo: sponsor11Logo },
    { id: 12, name: 'Sponsor 12', logo: sponsor12Logo },
    { id: 13, name: 'Sponsor 13', logo: sponsor13Logo },
    { id: 14, name: 'Sponsor 14', logo: sponsor14Logo },
    { id: 15, name: 'Sponsor 15', logo: sponsor15Logo },
  ];

  const parseSideDisplay = (displayString) => {
    if (!displayString) return { players: [], state: '' };

    const stateMatch = displayString.match(/\(([^)]+)\)\s*$/);
    const state = stateMatch ? stateMatch[1] : '';

    const namesOnly = displayString.replace(/\s*\([^)]+\)\s*$/, '').trim();

    let players = [];
    if (namesOnly.includes(' & ')) {
      players = namesOnly.split(' & ').map(p => p.trim());
    } else if (namesOnly.includes(' / ')) {
      players = namesOnly.split(' / ').map(p => p.trim());
    } else {
      players = [namesOnly];
    }

    return { players, state };
  };

  const fetchTournamentSideLabels = async () => {
    try {
      const response = await fetch(API_SIDE_LABELS);

      if (!response.ok) {
        return {};
      }

      const data = await response.json();

      const labelsMap = {};
      if (Array.isArray(data)) {
        data.forEach(item => {
          if (item.matchId) {
            labelsMap[item.matchId] = item;
          }
        });
      }

      return labelsMap;
    } catch (error) {
      console.error('Error fetching tournament side labels:', error);
      return {};
    }
  };

  const fetchMatchDetails = async (matchId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/${matchId}`);
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      console.error(`Error fetching match ${matchId}:`, error);
      return null;
    }
  };

  const getFirstName = (fullName) => {
    if (!fullName) return '';
    return fullName.trim().split(' ')[0];
  };

  const parsePlayerNames = (nameString) => {
    if (!nameString) return [];

    let players = [];

    if (nameString.includes(' & ')) {
      players = nameString.split(' & ').map(p => getFirstName(p));
    } else if (nameString.includes(' / ')) {
      players = nameString.split(' / ').map(p => getFirstName(p));
    } else if (nameString.includes('/')) {
      players = nameString.split('/').map(p => getFirstName(p));
    } else {
      players = [getFirstName(nameString)];
    }

    return players.filter(p => p.length > 0);
  };

  const convertApiDataToMatch = (apiData, liveData, sideLabelsData = null) => {
    const matchData = apiData || liveData;
    const sets = matchData.sets || [];

    let currentSetNumber = 1;
    if (liveData?.currentSetNumber) {
      currentSetNumber = liveData.currentSetNumber;
    } else {
      for (let i = sets.length - 1; i >= 0; i--) {
        const set = sets[i];
        const s1 = set.side1Score || 0;
        const s2 = set.side2Score || 0;

        const isComplete = (s1 >= 21 && s1 - s2 >= 2) ||
          (s2 >= 21 && s2 - s1 >= 2) ||
          (s1 >= 30 || s2 >= 30);

        if (!isComplete && (s1 > 0 || s2 > 0)) {
          currentSetNumber = i + 1;
          break;
        } else if (isComplete) {
          currentSetNumber = i + 2;
          break;
        }
      }
      if (currentSetNumber > 3) currentSetNumber = 3;
    }

    let p1A = "", p1B = "", p2A = "", p2B = "";
    let side1State = "", side2State = "";

    if (sideLabelsData) {
      if (sideLabelsData.side1Display) {
        const side1Parts = parseSideDisplay(sideLabelsData.side1Display);
        p1A = side1Parts.players[0] || "";
        p1B = side1Parts.players[1] || "";
        side1State = side1Parts.state || "";
      }

      if (sideLabelsData.side2Display) {
        const side2Parts = parseSideDisplay(sideLabelsData.side2Display);
        p2A = side2Parts.players[0] || "";
        p2B = side2Parts.players[1] || "";
        side2State = side2Parts.state || "";
      }
    }

    const isDoublesCategory = matchData.categoryName?.toLowerCase().includes('doubles');
    const hasDoublesPlayers = (p1B && p1B.trim() !== "") || (p2B && p2B.trim() !== "") ||
      (sideLabelsData && (sideLabelsData.player1BId || sideLabelsData.player2BId));

    const side1Name = matchData.side1Label || 'Player 1';
    const side2Name = matchData.side2Label || 'Player 2';

    let side1Players = [];
    let side2Players = [];

    if (isDoublesCategory || hasDoublesPlayers) {
      if (p1A && p1A.trim() !== "") {
        side1Players.push(getFirstName(p1A));
      }
      if (p1B && p1B.trim() !== "") {
        side1Players.push(getFirstName(p1B));
      }
      if (p2A && p2A.trim() !== "") {
        side2Players.push(getFirstName(p2A));
      }
      if (p2B && p2B.trim() !== "") {
        side2Players.push(getFirstName(p2B));
      }

      if (side1Players.length === 0) {
        side1Players = parsePlayerNames(side1Name);
      }
      if (side2Players.length === 0) {
        side2Players = parsePlayerNames(side2Name);
      }
    } else {
      if (p1A && p1A.trim() !== "") {
        side1Players.push(getFirstName(p1A));
      } else {
        side1Players = parsePlayerNames(side1Name);
      }

      if (p2A && p2A.trim() !== "") {
        side2Players.push(getFirstName(p2A));
      } else {
        side2Players = parsePlayerNames(side2Name);
      }
    }

    const side1Scores = [0, 0, 0];
    const side2Scores = [0, 0, 0];

    sets.forEach((set, index) => {
      if (index < 3) {
        side1Scores[index] = set.side1Score || 0;
        side2Scores[index] = set.side2Score || 0;
      }
    });

    const courtNumber = liveData?.courtNumber || 1;
    const isDoubles = isDoublesCategory || hasDoublesPlayers || side1Players.length > 1 || side2Players.length > 1;

    if (isDoubles) {
      return {
        id: matchData.matchId || liveData.matchId,
        matchType: `${matchData.categoryName} - ${matchData.roundName}`,
        courtNumber: courtNumber,
        team1: {
          players: side1Players,
          state: side1State,
          scores: side1Scores,
          serving: matchData.currentServerSide === 1
        },
        team2: {
          players: side2Players,
          state: side2State,
          scores: side2Scores,
          serving: matchData.currentServerSide === 2
        },
        currentSet: currentSetNumber,
        status: matchData.status || liveData?.matchStatus,
        isDoubles: true
      };
    } else {
      return {
        id: matchData.matchId || liveData.matchId,
        matchType: `${matchData.categoryName} - ${matchData.roundName}`,
        courtNumber: courtNumber,
        player1: {
          name: side1Players[0] || side1Name,
          state: side1State,
          scores: side1Scores,
          serving: matchData.currentServerSide === 1
        },
        player2: {
          name: side2Players[0] || side2Name,
          state: side2State,
          scores: side2Scores,
          serving: matchData.currentServerSide === 2
        },
        currentSet: currentSetNumber,
        status: matchData.status || liveData?.matchStatus,
        isDoubles: false
      };
    }
  };

  const fetchAllMatches = async (silent = false) => {
    try {
      if (!silent) setLoading(true);
      setError(null);

      const sideLabelsMap = await fetchTournamentSideLabels();

      const response = await fetch(API_ALL_LIVE);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const allMatchesData = await response.json();

      if (!Array.isArray(allMatchesData) || allMatchesData.length === 0) {
        setLiveMatchesByGroup({});
        setNextMatchesByGroup({});
        if (!silent) setLoading(false);
        setLastUpdate(new Date().toLocaleTimeString());
        return;
      }

      const inProgressMatches = allMatchesData.filter(match => match.matchStatus === "In Progress");

      const detailedLiveMatches = await Promise.all(
        inProgressMatches.map(async (liveMatch) => {
          const details = await fetchMatchDetails(liveMatch.matchId);
          const sideLabels = sideLabelsMap[liveMatch.matchId] || null;
          return convertApiDataToMatch(details, liveMatch, sideLabels);
        })
      );

      const liveByGroup = {};
      detailedLiveMatches.forEach(match => {
        const courtKey = `court${match.courtNumber}`;
        liveByGroup[courtKey] = match;
      });

      setLiveMatchesByGroup(liveByGroup);
      setLastUpdate(new Date().toLocaleTimeString());
      if (!silent) setLoading(false);
    } catch (error) {
      console.error('Error fetching matches:', error);
      setError(error.message);
      if (!silent) setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllMatches();

    pollingIntervalRef.current = setInterval(() => {
      fetchAllMatches(true);
    }, 5000);

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
      }
    };
  }, []);

  const formatPlayerName = (participant) => {
    if (participant.players && Array.isArray(participant.players)) {
      return participant.players.join(' & ');
    }
    return participant.name || 'Unknown';
  };

  const getSetWinner = (match, setIndex) => {
    if (!match) return null;
    const p1Score = match.isDoubles ? match.team1.scores[setIndex] : match.player1.scores[setIndex];
    const p2Score = match.isDoubles ? match.team2.scores[setIndex] : match.player2.scores[setIndex];

    if (p1Score === undefined || p2Score === undefined) return null;
    if (p1Score >= 21 && p1Score - p2Score >= 2) return 1;
    if (p2Score >= 21 && p2Score - p1Score >= 2) return 2;
    if (p1Score >= 30 || p2Score >= 30) return p1Score > p2Score ? 1 : 2;
    return null;
  };

  const renderCourtCard = (court) => {
    const liveMatch = liveMatchesByGroup[court.id];

    return (
      <div key={court.id} className="court-card">
        <div className="court-card-header">
          <div className="court-header-left">
            <div className="court-card-name">{court.name}</div>
            {liveMatch && (
              <div className="match-type-header">{liveMatch.matchType}</div>
            )}
          </div>
        </div>

        {liveMatch ? (
          <div className="court-live-match">
            <div className="scoreboard-compact">
              <div className={`player-row-compact ${(liveMatch.isDoubles ? liveMatch.team1.serving : liveMatch.player1.serving) ? 'serving' : ''}`}>
                <div className="player-info-compact">
                  <div className="player-text-compact">
                    <div className="player-name-compact">
                      {liveMatch.isDoubles ? formatPlayerName(liveMatch.team1) : liveMatch.player1.name}
                    </div>
                    <div className="player-state-compact">
                      {liveMatch.isDoubles ? liveMatch.team1.state : liveMatch.player1.state}
                    </div>
                  </div>
                </div>
                <div className="scores-and-service">
                  <div className="service-shuttle-compact">
                    {(liveMatch.isDoubles ? liveMatch.team1.serving : liveMatch.player1.serving) && (
                      <span className="shuttle-icon-large">🏸</span>
                    )}
                  </div>
                  <div className="scores-compact">
                    {[0, 1, 2].map((setIndex) => {
                      const score = liveMatch.isDoubles ? liveMatch.team1.scores[setIndex] : liveMatch.player1.scores[setIndex];
                      const isCurrentSet = liveMatch.currentSet === setIndex + 1;
                      const setWinner = getSetWinner(liveMatch, setIndex);

                      return (
                        <div key={setIndex} className={`score-compact ${isCurrentSet ? 'current' : ''} ${setWinner === 1 ? 'won' : ''} ${score === undefined || score === 0 ? 'empty' : ''}`}>
                          {score !== undefined && score > 0 ? score : '-'}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className={`player-row-compact ${(liveMatch.isDoubles ? liveMatch.team2.serving : liveMatch.player2.serving) ? 'serving' : ''}`}>
                <div className="player-info-compact">
                  <div className="player-text-compact">
                    <div className="player-name-compact">
                      {liveMatch.isDoubles ? formatPlayerName(liveMatch.team2) : liveMatch.player2.name}
                    </div>
                    <div className="player-state-compact">
                      {liveMatch.isDoubles ? liveMatch.team2.state : liveMatch.player2.state}
                    </div>
                  </div>
                </div>
                <div className="scores-and-service">
                  <div className="service-shuttle-compact">
                    {(liveMatch.isDoubles ? liveMatch.team2.serving : liveMatch.player2.serving) && (
                      <span className="shuttle-icon-large">🏸</span>
                    )}
                  </div>
                  <div className="scores-compact">
                    {[0, 1, 2].map((setIndex) => {
                      const score = liveMatch.isDoubles ? liveMatch.team2.scores[setIndex] : liveMatch.player2.scores[setIndex];
                      const isCurrentSet = liveMatch.currentSet === setIndex + 1;
                      const setWinner = getSetWinner(liveMatch, setIndex);

                      return (
                        <div key={setIndex} className={`score-compact ${isCurrentSet ? 'current' : ''} ${setWinner === 2 ? 'won' : ''} ${score === undefined || score === 0 ? 'empty' : ''}`}>
                          {score !== undefined && score > 0 ? score : '-'}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="set-info-compact">Set {liveMatch.currentSet}</div> */}
          </div>
        ) : (
          <div className="no-match-compact">
            <div className="no-match-icon-small">🏸</div>
            <div className="no-match-text">
              {loading && !lastUpdate ? 'Loading...' : 'No Live Match'}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="all-courts-container">
      <header className="all-courts-header">
        <div className="header-content">
          <h1 className="tournament-title">
            Yonex-Sunrise 4th Mini National Badminton Championship-2025
          </h1>
          {/* <div className="header-right-section">
            {lastUpdate && (
              <div className="last-update-info">Last updated: {lastUpdate}</div>
            )}
          </div> */}
        </div>
      </header>

      {error && (
        <div style={{ background: '#fee', border: '1px solid #fcc', padding: '15px', borderRadius: '8px', margin: '20px', color: '#c33' }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      <main className="courts-grid">
        {courts.map((court) => renderCourtCard(court))}
      </main>

      <div className="sponsors-section">
        <div className="sponsors-container">
          {/* Main Sponsors Row - Sponsor 7 and 10 */}
          <div className="main-sponsors-row">
            <div className="main-sponsor-wrapper">
              <img src={sponsor7Logo} alt="Sponsor 7" className="sponsor-logo" />
            </div>
            <div className="main-sponsor-wrapper">
              <img src={sponsor10Logo} alt="Sponsor 10" className="sponsor-logo" />
            </div>
          </div>

          {/* Other Sponsors Row */}
          <div className="other-sponsors-row">
            {sponsors
              .filter(sponsor => sponsor.id !== 7 && sponsor.id !== 10)
              .map((sponsor) => (
                <div key={sponsor.id} className="sponsor-logo-wrapper">
                  <img src={sponsor.logo} alt={sponsor.name} className="sponsor-logo" />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllCourtsScreen;